export function getSessionToken() {
  return location.pathname.slice(1);
}
